export enum CollectionPoolType {
    Dedicate = 'pcp',
    Shared = 'npcp',
    W10Dedicated = 'w10dd',
    W10Pooled = 'w10pd'
}
